export { SEOTemplate } from './SEOTemplate';
